/* eslint-disable */

import axios from 'axios';
import moment from 'moment-timezone';
import { extractApiError } from '@/utils/apiError';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {
  namespaced: true,
  state: {
    queryResults: [],
    // used to track some custom things such as on Aging page - show claims older than how many days? Property = custom.agingOlderThan
    custom: {
        agingOlderThan: 30
    },
    claims: []
  },

  getters: {
      queryResults: (state)  => state.queryResults,

      custom: (state) => state.custom,

      claims: (state) => state.claims
  },

  mutations: {
    setQueryResults(state, queryResults) {
        state.queryResults.push(queryResults);
    },

    setCustom(state, payload) {
        state.custom = payload;
    },

    setClaims(state, payload) {
        state.claims = payload;
    },

    emptyResults(state) {
        state.queryResults.length = 0;
        state.queryResults = [];
    }
  },

  actions: {
    async getSiteInfo({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            let response = await axios.post(`/get-site-info`, payload, { crossdomain: true});            
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});            
            return response;
        }
        catch(err) {
            console.log('Error getting site info:', err);
            dispatch('alert/setErrored', true, {root: true});            
            dispatch('alert/setMessage', err, {root: true});
        }
    },

    async getPaymentInfo({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            let response = await axios.post(`/get-payment-info`, payload, { crossdomain: true});            
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});            
            return response;
        }
        catch(err) {
            console.log('Error getting payment info:', err);
            dispatch('alert/setErrored', true, {root: true});            
            dispatch('alert/setMessage', err, {root: true});
        }
    },

    async savePaymentInfo({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            let response = await axios.post(`/save-payment-info`, payload, { crossdomain: true});            
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});            
            return response;
        }
        catch(err) {
            console.log('Error saving payment info:', err);
            throw err;
            /*            
            dispatch('alert/setErrored', true, {root: true});            
            dispatch('alert/setMessage', err, {root: true});
            */
        }
    },

    /**
     * Create a Stripe Payment Link for text-to-pay
     * Returns { paymentUrl, totalCharge, stripeFee, originalBalance, expiresAt }
     */
    async createPaymentLink({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading2', true, {root: true});
            let response = await axios.post(`/create-payment-link`, payload, { crossdomain: true});            
            dispatch('alert/setLoading2', false, {root: true});
            return response.data;
        }
        catch(err) {
            console.log('Error creating payment link:', err);
            dispatch('alert/setLoading2', false, {root: true});
            dispatch('alert/setErrored2', true, {root: true});            
            dispatch('alert/setMessage2', err.response?.data?.message || err.message, {root: true});
            throw err;
        }
    },

    /**
     * Get payment status by paymentId
     */
    async getPaymentStatusById({commit, dispatch}, paymentId) {
        try {
            let response = await axios.get(`/payment-status/${paymentId}`, { crossdomain: true});            
            return response.data;
        }
        catch(err) {
            console.log('Error getting payment status:', err);
            throw err;
        }
    },

    // ==================== Payment Configuration ====================
    
    async getPaymentConfig({commit, dispatch}, siteID) {
        try {
            let response = await axios.get(`/payment-config?siteID=${siteID}`, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error getting payment config:', err);
            throw err;
        }
    },

    async savePaymentConfig({commit, dispatch}, payload) {
        try {
            let response = await axios.post(`/payment-config`, payload, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error saving payment config:', err);
            throw err;
        }
    },

    async validateCardpointeCredentials({commit, dispatch}, payload) {
        try {
            let response = await axios.post(`/payment-config/validate-cardpointe`, payload, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error validating CardPointe credentials:', err);
            throw err;
        }
    },

    // ── Text-to-pay → Open Dental settings (card-brand → PayType mapping + prepayment) ──

    async getTextToPaySettings({commit, dispatch}, siteID) {
        try {
            let response = await axios.get(`/text-to-pay-settings?siteID=${siteID}`, { crossdomain: true });
            return response.data; // { settings: { creditCardPayTypeByBrand, prepaymentUnearnedType } }
        }
        catch(err) {
            console.log('Error getting text-to-pay settings:', err);
            throw err;
        }
    },

    async saveTextToPaySettings({commit, dispatch}, payload) {
        try {
            let response = await axios.post(`/text-to-pay-settings`, payload, { crossdomain: true });
            return response.data; // { settings: <stored blob> }
        }
        catch(err) {
            console.log('Error saving text-to-pay settings:', err);
            throw err;
        }
    },

    async getOdPaymentDefinitions({commit, dispatch}, siteID) {
        try {
            let response = await axios.get(`/od-payment-definitions?siteID=${siteID}`, { crossdomain: true });
            return response.data; // { payTypes: [{DefNum, ItemName, suggestedBrand}], unearnedTypes: [{DefNum, ItemName}] }
        }
        catch(err) {
            console.log('Error getting OD payment definitions:', err);
            throw err;
        }
    },

    // Text-to-pay payments + their Open Dental sync status, for the MyAccount
    // admin oversight table.
    //
    // `from`/`to` are INCLUSIVE site-local 'YYYY-MM-DD' dates that scope the
    // list to a business day for end-of-day reconciliation; the backend
    // resolves them against the site's own timezone and filters/sorts on PaidAt.
    // Omit both and the backend keeps its legacy newest-N-by-CreatedAt shape.
    //
    // Accepts a plain siteID string for backwards compatibility with any older
    // caller that hasn't moved to the object payload.
    async getOdSyncStatusList({commit, dispatch}, payload) {
        const { siteID, from, to, limit } = (typeof payload === 'string') ? { siteID: payload } : (payload || {});
        try {
            const qs = [`siteID=${encodeURIComponent(siteID)}`];
            if (from) qs.push(`from=${encodeURIComponent(from)}`);
            if (to) qs.push(`to=${encodeURIComponent(to)}`);
            if (limit) qs.push(`limit=${encodeURIComponent(limit)}`);
            let response = await axios.get(`/od-sync-status-list?${qs.join('&')}`, { crossdomain: true });
            return response.data; // { payments: [...], truncated: bool, range: {...}|null }
        }
        catch(err) {
            console.log('Error getting OD sync status list:', err);
            throw err;
        }
    },

    // ==================== Stripe Connect (OAuth + status + disconnect) ====================
    // See teamio-serverless-api/payment-service/stripe-oauth.js for backend handlers.

    /**
     * Returns the connect.stripe.com OAuth URL the practice should be sent to.
     * Response: { url, state }
     */
    async getStripeOAuthUrl({commit, dispatch}, siteID) {
        try {
            let response = await axios.get(`/stripe/oauth/start?siteID=${siteID}`, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error getting Stripe OAuth URL:', err);
            throw err;
        }
    },

    /**
     * Refreshes verification status from Stripe and returns it.
     * Response: { connected, accountId, chargesEnabled, payoutsEnabled,
     *             requirementsCurrentlyDue, connectedAt, lastCheckedAt, stale }
     */
    async getStripeAccountStatus({commit, dispatch}, siteID) {
        try {
            let response = await axios.get(`/stripe/account-status?siteID=${siteID}`, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error getting Stripe account status:', err);
            throw err;
        }
    },

    /**
     * Calls oauth.deauthorize on Stripe + clears the site's connection rows.
     * Payload: { siteID, updatedBy }
     */
    async disconnectStripeAccount({commit, dispatch}, payload) {
        try {
            let response = await axios.post(`/stripe/disconnect`, payload, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error disconnecting Stripe:', err);
            throw err;
        }
    },

    /**
     * Create a Stripe PaymentIntent on the practice's connected account for
     * the in-office Stripe Elements modal flow.
     * Payload: { siteID, patNum, amount, patientName, patientPhone, note }
     * Response: { paymentID, clientSecret, stripeAccountId, publishableKey, amount }
     */
    async createStripePaymentIntent({commit, dispatch}, payload) {
        try {
            let response = await axios.post(`/create-stripe-payment-intent`, payload, { crossdomain: true });
            return response.data;
        }
        catch(err) {
            console.log('Error creating Stripe payment intent:', err);
            throw err;
        }
    },

    // ==================== End Payment Configuration ====================

    async sendTextMsg({commit, dispatch}, payload) {
        try {            
            let response = await axios.post(`/send-text-msg`, payload, { crossdomain: true});            
            return response;
        }
        catch(err) {
            console.log('Error sending text msg:', err);       
            dispatch('alert/setErrored', true, {root: true});
            
            // Extract proper error message (fixes TxtMsgOk=2 display issue)
            const errorMessage = extractApiError(err, 'Failed to send text message');
            
            dispatch('alert/setMessage', errorMessage, {root: true});
            throw err;
        }
    },

    async sendEmailMsg({commit, dispatch}, payload) {
        try {            
            let response = await axios.post(`/send-email-msg`, payload, { crossdomain: true});                        
            return response;
        }
        catch(err) {
            console.log('Error sending email msg:', err);
            dispatch('alert/setErrored', true, {root: true});            
            
            // Extract proper error message 
            const errorMessage = extractApiError(err, 'Failed to send email message');
            
            dispatch('alert/setMessage', errorMessage, {root: true});
        }
    },

    async saveAsap({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading2', true, {root: true});
            let response = await axios.post(`/save-asap`, payload, { crossdomain: true});            
            dispatch('alert/setLoading2', false, {root: true});
            dispatch('alert/setLoaded2', true, {root: true});
            //dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            return response;
        }
        catch(err) {
            console.log('Error saving ASAP list:', err);
            dispatch('alert/setErrored2', true, {root: true});            
            dispatch('alert/setMessage2', err, {root: true});
            throw err;
        }
    },

    async getAsap({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading2', true, {root: true});
            let response = await axios.post(`/get-asap`, payload, { crossdomain: true});            
            dispatch('alert/setLoading2', false, {root: true});
            dispatch('alert/setLoaded2', true, {root: true});
            dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            return response;
        }
        catch(err) {
            console.log('Error getting ASAP list:', err);
            dispatch('alert/setErrored2', true, {root: true});            
            dispatch('alert/setMessage2', err, {root: true});
            throw err;
        }
    },

    async runQuery({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            // Large /runquery responses come back gzip-compressed via API Gateway
            // (Content-Encoding: gzip, isBase64Encoded on the Lambda side). The
            // browser decompresses transparently, so axios always sees plain JSON.
            let response = await axios.post(`/runquery`, payload, { crossdomain: true, timeout: 250000 });

            commit('setQueryResults', response);
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});
            return response;
        }
        catch(err) {
            console.log('Error running query:', err);
            dispatch('alert/setErrored', true, {root: true});

            if (err.code === 'ECONNABORTED') {
                dispatch('alert/setMessage', 'Your request took too long. Please wait and try again later.', {root: true});
            } else            
                dispatch('alert/setMessage', err, {root: true});
        }
    },

    /**
     * Same /runquery endpoint as runQuery above, but SIDE-EFFECT FREE — for a report
     * that loads inside a slide-out/drawer on top of a page that has its own data.
     *
     * Deliberately does NOT:
     *   - commit('setQueryResults')       -> would grow shared state the host page reads
     *   - dispatch('alert/setLoading')    -> would spin the HOST page's overlay
     *   - dispatch('alert/setErrored')    -> would paint the HOST page's <ErrorDisplay/>
     *
     * Callers own their own spinner and error message, and get the raw result-set
     * array back (one entry per statement the SQL builder emitted). Throws on
     * failure so the caller can show the error where the user is actually looking.
     */
    async runReportQuery({dispatch}, payload) {
        try {
            let response = await axios.post(`/runquery`, payload, { crossdomain: true, timeout: 250000 });
            return response.data;
        }
        catch(err) {
            console.log('Error running report query:', err);
            throw err;
        }
    },

    // function that tracks when someone starts making a follow-up attempt so that if someone else tries to access it at the same time, they'll be warned
    async startTrackingFUAttempt({ commit, rootState, dispatch}, payload) {

        try {
            await dispatch('cache/addValueToSet', payload, {root: true});
        } catch (error) {
            throw error;
        }

        /*
        try {
            let response = await axios.post(`/start-fu-attempt-tracking`, payload, { crossdomain: true });
            return response;
        }
        catch(err) {
            console.log('Error tracking followup attempt:', err);
        }*/
    },

    async stopTrackingFUAttempt({ commit, rootState, dispatch}, payload) {
        // Retry once on transient failure
        try {
            await dispatch('cache/removeValueFromSet', payload, {root: true});
        } catch (error) {
            console.warn('[FOLLOWUP] stopTrackingFUAttempt failed, retrying once...', error);
            try {
                await dispatch('cache/removeValueFromSet', payload, {root: true});
            } catch (err2) {
                console.error('[FOLLOWUP] stopTrackingFUAttempt failed after retry', err2);
                throw err2;
            }
        }
        
        /*
        try {
            let response = await axios.post(`/stop-fu-attempt-tracking`, payload, { crossdomain: true });          
            return response;
        }
        catch(err) {
            console.log('Error stopping followup attempt tracking:', err);
        }
        */
    },

    /*
    async getClaims({commit, rootState, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            let claimsRef = rootState.db.collection('tasks');
            let end = moment().utc().subtract(payload.agingOlderThan, 'days').toDate();
            //console.log('end date:' + end);
            let tempClaims = [];

            claimsRef.where('SiteID', '==', payload.siteID).where('TaskType', '==', 'UNPAID_CLAIM').where('DateSent', '<=', end).onSnapshot(function(claimsSnapshot) {
                for(const claim of claimsSnapshot.docs) {
                    const tempClaim = claim.data();
                    tempClaim.id = claim.id;
                    tempClaim.CreatedAt = tempClaim.CreatedAt ? moment(tempClaim.CreatedAt.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.DueDate = tempClaim.DueDate ? moment(tempClaim.DueDate.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.Birthdate = tempClaim.Birthdate ? moment(tempClaim.Birthdate.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.DateSent = tempClaim.DateSent ? moment(tempClaim.DateSent.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.DateService = tempClaim.DateService ? moment(tempClaim.DateService.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.SubscriberBirthDate = tempClaim.SubscriberBirthDate ? moment(tempClaim.SubscriberBirthDate.toDate()).format('MM/DD/YYYY') : '';
                    tempClaim.FollowupDate = tempClaim.FollowupDate && typeof tempClaim.FollowupDate !== 'string' ? moment(tempClaim.FollowupDate.toDate()).format('MM/DD/YYYY') : '';
                    tempClaims.push(tempClaim);
                }
            });

            commit('setClaims', tempClaims);
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});
        }
        catch(err) {
            console.log('Error running query:', err);
            dispatch('alert/setErrored', true, {root: true});
            dispatch('alert/setMessage', err, {root: true});
        }
    }
    */


  }

};
